<template>
  <footer>
    <div class="footer-container">
      <a href="mailto:kerdes@bankszamlakivonat.hu">kapcsolat</a>
      <a href="https://bankszamlakivonat.hu/wp-content/uploads/2025/04/Hatalyos_ASZF.pdf" target="_blank">ÁSZF</a>
      <a href="https://bankszamlakivonat.hu/wp-content/uploads/2025/04/Hatalyos_Adatkezelesi-Tajekoztato.pdf"
        target="_blank">adatkezelési tájékoztató</a>
      <a href="https://bankszamlakivonat.hu/wp-content/uploads/2025/04/Hatalyos_Cookie_tajekoztato.pdf"
        target="_blank">cookie szabályzat</a>
    </div>
  </footer>
</template>

<script>
import "./_vpd-footer.scss";

export default {};
</script>
